import { config } from '../../config/config';
import { PaymentProvider } from './paymentProvider';
import { PaymentRequest, PaymentResponse, PaymentVerification } from '../../types/payment';

const logger = {
  error: (...args) => console.error(...args)
};

export class CampayService implements PaymentProvider {
  private readonly baseUrl = 'https://api.campay.net/api';
  private readonly headers: HeadersInit;

  constructor() {
    this.headers = {
      'Authorization': `Token ${config.campayApiKey}`,
      'Content-Type': 'application/json'
    };
  }

  async initializePayment(request: PaymentRequest): Promise<PaymentResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/collect/`, {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify({
          amount: request.amount,
          currency: 'XAF',
          from: request.phoneNumber,
          description: request.description,
          external_reference: request.reference,
          redirect_url: `${config.baseUrl}/payment/callback`
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Payment initialization failed');
      }

      const data = await response.json();
      return {
        reference: data.reference,
        paymentUrl: data.payment_url,
        status: 'pending'
      };
    } catch (error) {
      logger.error('Campay payment initialization error:', error);
      throw error;
    }
  }

  async verifyPayment(reference: string): Promise<PaymentVerification> {
    try {
      const response = await fetch(`${this.baseUrl}/transaction/${reference}/`, {
        headers: this.headers
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Payment verification failed');
      }

      const data = await response.json();
      return {
        reference: data.reference,
        status: this.mapPaymentStatus(data.status),
        amount: data.amount
      };
    } catch (error) {
      logger.error('Campay payment verification error:', error);
      throw error;
    }
  }

  private mapPaymentStatus(status: string): 'pending' | 'successful' | 'failed' {
    switch (status.toLowerCase()) {
      case 'successful':
        return 'successful';
      case 'failed':
        return 'failed';
      default:
        return 'pending';
    }
  }
}